import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `TipoIntervencion/addTipoIntervencion`, method: 'POST', body: values, token: token})
}
